import { Button } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  border-radius: 12px;
`;

export const FlagImage = styled.img`
  width: 32px;
  height: 32px;
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.black7};
  text-align: center;
  font-size: 15px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin: 0 0 24px 0;
  max-width: 400px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledButton = styled(Button)`
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.black6} !important;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black9};

  &:hover {
    background: ${({ theme }) => theme.colors.white} !important;
    color: ${({ theme }) => theme.colors.green6} !important;
    border: 1px solid ${({ theme }) => theme.colors.green6} !important;
  }
`;
